import Modal from 'bootstrap/js/dist/modal';
import Bowser from 'bowser';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'; // 1. Import this

// 2. Register the plugin
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

import { navActiveState } from './_nav-active-state.js';
import { initVideoModals } from './_video-modals.js';
import { initScrollAnimations } from './_scrollfx';
import { initPinnedCards } from './_pinnedfx';

// In main.js
gsap.to(document.body, {
   autoAlpha: 1,
   duration: 0.6,
   ease: 'power2.out',
   delay: 0.1,
});

function bowserInit() {
   const browser = Bowser.getParser(window.navigator.userAgent);
   const browserName = browser.getBrowserName();

   // Sanitize the string by lowercasing and replacing spaces with hyphens
   const sanitizedName = browserName.toLowerCase().replace(/\s+/g, '-');
   const nameString = `browser-name-${sanitizedName}`;

   if (browserName === 'Safari') {
      document.body.classList.add('is-safari');
   } else {
      document.body.classList.add(nameString);
   }
}

bowserInit();

document.addEventListener('DOMContentLoaded', () => {
   navActiveState();
   initVideoModals();
   initScrollAnimations();
   initPinnedCards();

   if (window.location.hash) {
      const target = document.querySelector(window.location.hash);

      if (target) {
         // Force GSAP to instantly calculate all pin spacer heights
         ScrollTrigger.refresh();

         // Override the native browser jump and scroll to the new, corrected position
         gsap.to(window, {
            duration: 0, // 0 means instant jump. Change to 1 for a smooth scroll on load!
            scrollTo: { y: target, autoKill: false },
            delay: 0.1, // A tiny delay ensures the browser's native jump has finished first
         });
      }
   }
});
